export default __webpack_public_path__ + "static/media/icontransparent.ce7626fa.png";